module.exports = __webpack_public_path__ + "media/images/slider_h1_02-d83d2ce79401866e6d77f480dfc825a2.png";